module.exports = __webpack_public_path__ + "static/media/image (8).6600bb20.jpg";